module.exports = __webpack_public_path__ + "static/img/cdi.2ec8887f.png";